module.exports = __webpack_public_path__ + "img/success2.b34f9bd3.jpeg";